// extracted by mini-css-extract-plugin
module.exports = {"currentYear":"jut__MonthYearFieldCustomHeader__currentYear"};